import React, { memo, useMemo, useState } from 'react'
import styles from './VNCategories.module.scss'
import { useSelector } from 'react-redux'
import { ButtonBase } from '@material-ui/core'
import { getSortedItemCategories } from '../../selectors/itemCategory'
import FavoriteIcon from './VNFavoriteIcon'
import { ReactComponent as InputSearchIcon } from '../../assets/input-search-icon.svg'
import VNCategorySearch from './VNCategorySearch'
import VNCategoryPill from './VNCategoryPill'
import { SHIFT4_BLUE } from '../../styles/constants'
import { ALL_ID, ALL_LABEL, FAVORITES_ID, FAVORITES_LABEL } from '../Selectors'
import VNCategoryDropdown from './VNCategoryDropdown'
import { isE700Device } from '../../VNAndroidSDK/Utils'

export const CATEGORY_DEFAULTS = [
  { id: FAVORITES_ID, name: <FavoriteIcon />, color: SHIFT4_BLUE, label: FAVORITES_LABEL },
  { id: ALL_ID, name: 'All', color: SHIFT4_BLUE, label: ALL_LABEL },
]

/**
 * VNCategories component displays filter of categories for menu items
 *
 * @returns {JSX.Element}
 */
const VNCategories = () => {
  const isMobile = useMemo(() => window.matchMedia('(max-width: 768px)').matches, [])
  const [showInput, setShowInput] = useState(isMobile)

  const itemCategoriesSorted = useSelector(getSortedItemCategories)
  const categories = useMemo(() => [...CATEGORY_DEFAULTS, ...Object.values(itemCategoriesSorted)], [itemCategoriesSorted])

  // mobile navigation
  if (isMobile) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <VNCategorySearch />
        </div>
        <div className={styles.container}>
          <VNCategoryDropdown />
        </div>
      </div>
    )
  }

  // tablet navigation
  return (
    <div className={styles.wrapper}>
      {showInput && <VNCategorySearch hideSearch={() => setShowInput(false)} />}
      <div className={styles.container}>
        <div className={styles.categoryPills}>
          {categories.map((category, idx) => (
            <VNCategoryPill key={idx} category={category} />
          ))}
        </div>
        <ButtonBase
          disableRipple={isE700Device()}
          component="div"
          className={styles.magnifier}
          onClick={() => setShowInput(true)}
        >
          <InputSearchIcon />
        </ButtonBase>
      </div>
    </div>
  )
}

export default memo(VNCategories)
